import { BaseResource } from "utils/ApiUtils";

class Delay extends BaseResource {
  constructor(args) {
    super(args, Delay.attributes);
  }

  static columns = [
    {
      title: "Project Id",
      field: "ProjectId_WorkItem",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Delay Id",
      field: "delayId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Ihwi Id",
      field: "ihwiId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Occurence Date",
      field: "occurenceDate",
      type: "date",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    { type: "string", title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Reason",
      field: "reason",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Impact Days",
      field: "impactDays",
      type: "numeric",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Impact Hours",
      field: "impactHours",
      type: "numeric",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Comments",
      field: "comments",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
  ];

  static attributes = Delay.columns.map((r) => r.field);

  static expand = [
    {
      "Ihwi": {
        expand: [
          {
            "WorkItem": {
              select: ["ProjectId"]
            }   
          },
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    },
];
}

export default Delay;
